import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { Page } from '@bonanza-social/navigation';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { Box, Loader } from '@bonanza-social/moonlight';
import {
  fetchPrizeWall,
  selectPrizeWallDataState,
} from '../state/prizeWall/prizeWall.slice';
import { selectPrizeWallCampaignDataState } from '../state/prizeWallCampaign/prizeWallCampaign.slice';
import PrizeWallInfoBackground from '../components/PrizeWallInfo/PrizeWallInfoBackground/PrizeWallInfoBackground';
import PrizeWallInfoHeader from '../components/PrizeWallInfo/PrizeWallInfoHeader/PrizeWallInfoHeader';
import PrizeWallInfo from '../components/PrizeWallInfo/PrizeWallInfo';

function PrizeWallInfoPage() {
  const dispatch = useDispatch();
  const campaignDataState = useSelector(selectPrizeWallCampaignDataState);
  const wallDataState = useSelector(selectPrizeWallDataState);

  useEffect(() => {
    if (
      campaignDataState === 'fulfilled' &&
      (wallDataState === 'idle' || wallDataState === 'rejected')
    ) {
      dispatch(fetchPrizeWall());
    }
  }, [campaignDataState, wallDataState, dispatch]);

  return (
    <Page>
      {campaignDataState === 'pending' && <Loader margin="auto" />}
      {campaignDataState === 'rejected' && <Navigate to="/" replace />}
      {campaignDataState === 'fulfilled' && (
        <Box width="100%">
          <PrizeWallInfoBackground />
          <Box width="100%">
            <PrizeWallInfoHeader width="100%" />
            <PrizeWallInfo
              width="100%"
              margin="auto"
              paddingVertical="space-1000"
              paddingHorizontal="space-400"
              maxWidth={576}
            />
          </Box>
        </Box>
      )}
    </Page>
  );
}

export default PrizeWallInfoPage;
